import { apiCall } from "./service";
import {
  URL_GET_ROSTER_INVOICES,
  URL_PUBLIC_HOLIDAY_LIST,
  URL_ROSTERING_CHANGE_TIMESHEET_STATUS,
  URL_ROSTERING_CHECK_PAYROLL_AUTHENTICATION,
  URL_ROSTERING_CREATE_TIMESHEET_COMMENT,
  URL_ROSTERING_EXPORT_TIMESHEET_TO_PAYROLL,
  URL_ROSTERING_LATEST_SHIFT_PARTICIPANTS,
  URL_ROSTERING_NEW_TIMESHEET_GET_TIMESHEET_LIST_OF_WORKERS,
  URL_ROSTERING_PARTICIPANT_LIST_FOR_TIMESHEETS,
  URL_ROSTERING_SHIFT,
  URL_ROSTERING_SHIFT_ADVANCE,
  URL_ROSTERING_SHIFT_DRAFTS,
  URL_ROSTERING_SHIFT_DELETABLE_LIST,
  URL_ROSTERING_SHIFT_V5,
  URL_ROSTERING_V5_SHIFT_COPY,
  URL_ROSTERING_SHIFT_STATUS_CHANGE,
  URL_ROSTERING_SINGLE_TIMESHEET_DETAILS,
  URL_ROSTERING_TIMESHEET_COMMENTS,
  URL_ROSTERING_TIMESHEET_GET_WORKERS_OF_TIMESHEET_FOR_TABLE,
  URL_ROSTERING_UPDATE_TIMESHEET_DATA,
  URL_ROSTERING_WORKER_AND_PARTICIPANT_LIST,
  URL_ROSTERING_WORKER_TIMESHEETS,
  URL_ROSTERING_WORKERS_TIMESHEET_EXPORT_LIST,
  URL_ROSTERING_SIL_HOMES,
  URL_ROSTERING_SIL_HOME_PARTICIPANTS,
  URL_ROSTERING_COMMON_RESOURCES,
  URL_ROSTERING_SHIFT_LOCATION,
  URL_SHIFT_HISTORY,
  URL_SP_SHIFT_REQUESTS,
  URL_SP_SHIFT_REQUEST_STATUS,
  URL_SP_SHIFT_REQUEST_DETAIL,
} from "./URL";

const token = localStorage.getItem("accessToken");

export const api = {
  getWorkerAndParticipantList(params) {
    return apiCall.post({
      url: URL_ROSTERING_WORKER_AND_PARTICIPANT_LIST,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  createWorkerShift(params) {
    return apiCall.post({
      url: URL_ROSTERING_SHIFT,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  createAdvanceWorkerShift(params) {
    return apiCall.post({
      url: URL_ROSTERING_SHIFT_ADVANCE,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  /** Update a V5 advance (multi-assignment) shift: PUT /api/v5/sp/rostering/shift/{uuid}/advance */
  updateAdvanceWorkerShift(params) {
    return apiCall.put({
      url: `${URL_ROSTERING_SHIFT_V5}/${params.uuid}/advance`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  /**
   * DELETE /api/v5/sp/rostering/shift/{uuid}/shift-tasks/{taskId}
   * Removes one logical task, including its per-worker expansions.
   */
  deleteAdvanceShiftTask(params) {
    return apiCall.delete({
      url: `${URL_ROSTERING_SHIFT_V5}/${params.uuid}/shift-tasks/${params.taskId}`,
      isAuthToken: token,
      params: {},
    });
  },

  /** POST /api/v5/sp/rostering/shift-drafts — save incomplete advance builder */
  createAdvanceShiftDraft(params) {
    return apiCall.post({
      url: URL_ROSTERING_SHIFT_DRAFTS,
      isAuthToken: token,
      skipQueryParams: true,
      params,
    });
  },

  /** PUT /api/v5/sp/rostering/shift-drafts/{uuid} */
  updateAdvanceShiftDraft(params) {
    const { uuid, ...body } = params || {};
    return apiCall.put({
      url: `${URL_ROSTERING_SHIFT_DRAFTS}/${uuid}`,
      isAuthToken: token,
      skipQueryParams: true,
      params: body,
    });
  },

  /** GET /api/v5/sp/rostering/shift-drafts?from_date=&to_date=&page= */
  listAdvanceShiftDrafts(params = {}) {
    return apiCall.get({
      url: URL_ROSTERING_SHIFT_DRAFTS,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  /** GET /api/v5/sp/rostering/shift-drafts/{uuid} — resume form + payload */
  getAdvanceShiftDraft(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_SHIFT_DRAFTS}/${params.uuid}`,
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
    });
  },

  /** DELETE /api/v5/sp/rostering/shift-drafts/{uuid} — discard */
  deleteAdvanceShiftDraft(params) {
    return apiCall.delete({
      url: `${URL_ROSTERING_SHIFT_DRAFTS}/${params.uuid}`,
      isAuthToken: token,
      params: {},
    });
  },

  updateWorkerShift(params) {
    return apiCall.patch({
      url: `${URL_ROSTERING_SHIFT}/${params.uuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  shifthistory(params) {
    return apiCall.get({
      url: `${URL_SHIFT_HISTORY}/${params.shiftUuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  workerShiftDetails(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_SHIFT}/${params.shiftUuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  /** V5 advance (multi-assignment) shift details: GET /api/v5/sp/rostering/shift/{idOrUuid} */
  getAdvanceWorkerShiftDetails(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_SHIFT_V5}/${params.idOrUuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  /** Lean advance-shift hover card data: GET /api/v5/sp/rostering/shift/{idOrUuid}/hover-summary */
  getAdvanceShiftHoverSummary(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_SHIFT_V5}/${params.idOrUuid}/hover-summary`,
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
      signal: params.signal,
    });
  },
  deleteWorkerAndParticipantShift(params) {
    let url = `${URL_ROSTERING_SHIFT}/${params.shiftUuid}`;

    const requestConfig = {
      url: url,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    };

    // If recurring_impact is true, send additional data in request body
    if (params.recurring_impact === true) {
      const bodyData = {};
      
      // Add from_date and to_date if provided
      if (params.from_date) {
        bodyData.from_date = params.from_date;
      }
      if (params.to_date) {
        bodyData.to_date = params.to_date;
      }
      
      // Add view (participant or worker)
      if (params.type) {
        bodyData.type = params.type;
      }
      
      // Add worker or participant UUIDs if provided
      if (params.workers && Array.isArray(params.workers) && params.workers.length > 0) {
        bodyData.workers = params.workers;
      }
      if (params.participants && Array.isArray(params.participants) && params.participants.length > 0) {
        bodyData.participants = params.participants;
      }
      
      requestConfig.data = bodyData;
      
      // Add page and per_page as query parameters (same as worker_participant_list API)
      const queryParams = [`recurring_impact=${params.recurring_impact}`];
      
      if (params.page) {
        queryParams.push(`page=${params.page}`);
      }
      if (params.per_page) {
        queryParams.push(`per_page=${params.per_page}`);
      }
      
      url += `?${queryParams.join('&')}`;
      requestConfig.url = url;
    } else if (params.recurring_impact === false) {
      url += `?recurring_impact=${params.recurring_impact}`;
      requestConfig.url = url;
    }

    return apiCall.delete(requestConfig);
  },

  bulkDeleteWorkerAndParticipantShifts(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_SHIFT}/bulk-delete`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {
        uuids: params.uuids,
        recurring_impact: params.recurring_impact || false,
      },
    });
  },

  /** Flat deletable shifts for Delete Shifts modal (not the calendar list). */
  getDeletableShiftsList(params) {
    return apiCall.post({
      url: URL_ROSTERING_SHIFT_DELETABLE_LIST,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  // deleteWorkerAndParticipantShift(params) {
  //   return apiCall.delete({
  //     url: `${URL_ROSTERING_SHIFT}/${params.shiftUuid}`,
  //     isAuthToken: token,
  //     skipQueryParams: false,
  //     params: {},
  //   });
  // },

  changeStatusWorkerAndParticipantShift(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_SHIFT_STATUS_CHANGE}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  copyWorkerAndParticipantShift(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_V5_SHIFT_COPY}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  getParticipantListForTimesheet() {
    return apiCall.get({
      url: `${URL_ROSTERING_PARTICIPANT_LIST_FOR_TIMESHEETS}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  getWorkerTimeSheets(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_WORKER_TIMESHEETS}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: params,
    });
  },
  getTimesheetComments(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_TIMESHEET_COMMENTS}/${params.timeSheetUuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  createTimesheetComment(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_CREATE_TIMESHEET_COMMENT}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  updateTimesheetData(params) {
    return apiCall.patch({
      url: `${URL_ROSTERING_UPDATE_TIMESHEET_DATA}/${params?.uuids.timeSheetUuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: params.data,
    });
  },
  changeTimesheetStatus(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_CHANGE_TIMESHEET_STATUS}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  latestShiftParticipants() {
    return apiCall.get({
      url: `${URL_ROSTERING_LATEST_SHIFT_PARTICIPANTS}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  workerTimeSheetExportList(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_WORKERS_TIMESHEET_EXPORT_LIST}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  singleTimesheetDetails(params) {
    return apiCall.get({
      url: `${URL_ROSTERING_SINGLE_TIMESHEET_DETAILS}?uuid=${params.uuid}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  checkPayrollAuthentication() {
    return apiCall.get({
      url: `${URL_ROSTERING_CHECK_PAYROLL_AUTHENTICATION}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  exportTimesheetToPayroll(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_EXPORT_TIMESHEET_TO_PAYROLL}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  getRosterInvoicing(params) {
    return apiCall.get({
      url: `${URL_GET_ROSTER_INVOICES}?participant_id=${
        params?.participant_id ? params?.participant_id:""}&start_date=${params?.start_date}&end_date=${params?.end_date}&worker_id=${params?.worker_id ? params?.worker_id:""}&all_approved=${params?.all_approved ? params?.all_approved:false}&per_page=${params?.per_page ? params?.per_page:""}&page=${params?.page ? params?.page:""}`,
      isAuthToken: token,
      skipQueryParams: false,
      params:{},
    });
  },
  getPublicHolidaysOfStatesApi(params) {
   
    let url = `${URL_PUBLIC_HOLIDAY_LIST}?from=${params?.from}&to=${params?.to}`;

    return apiCall.get({
      url,
      isAuthToken: token,
      params: {},
      skipQueryParams: true,
    });
  },
  getTimesheetsOfWorkersService(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_NEW_TIMESHEET_GET_TIMESHEET_LIST_OF_WORKERS}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
    getTimesheetsOfSelectedWorker(params) {
    return apiCall.post({
      url: `${URL_ROSTERING_TIMESHEET_GET_WORKERS_OF_TIMESHEET_FOR_TABLE}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  getShiftRequests() {
    return apiCall.get({
      url: URL_SP_SHIFT_REQUESTS,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  /** Fresh request row (mobile/family) — no roster shift required. */
  getShiftRequestDetail(uuid) {
    return apiCall.get({
      url: `${URL_SP_SHIFT_REQUEST_DETAIL}/${uuid}`,
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
    });
  },
  getShiftRequestInReviewByShiftUuid(shiftUuid) {
    return apiCall.get({
      url: `${URL_SP_SHIFT_REQUEST_DETAIL}/by-shift/${shiftUuid}`,
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
    });
  },
  updateShiftRequestStatus(uuid, status, extraParams = {}) {
    return apiCall.post({
      url: `${URL_SP_SHIFT_REQUEST_STATUS}/${uuid}/status`,
      isAuthToken: token,
      skipQueryParams: false,
      params: { status, ...extraParams },
    });
  },
  logShiftCreatedFromRequest(uuid, params = {}) {
    return apiCall.post({
      url: `${URL_SP_SHIFT_REQUEST_STATUS}/${uuid}/shift-created`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },

  getSilHomes(params = {}) {
    const { signal, ...queryParams } = params || {};
    return apiCall.get({
      url: URL_ROSTERING_SIL_HOMES,
      isAuthToken: token,
      skipQueryParams: false,
      params: {
        per_page: 10,
        sort_field: "street_address",
        sort_order: "asc",
        ...queryParams,
      },
      signal,
    });
  },

  getSilHomeParticipants(homeUuid, options = {}) {
    return apiCall.get({
      url: URL_ROSTERING_SIL_HOME_PARTICIPANTS(homeUuid),
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
      signal: options.signal,
    });
  },

  postCommonResources(body, options = {}) {
    return apiCall.post({
      url: URL_ROSTERING_COMMON_RESOURCES,
      isAuthToken: token,
      skipQueryParams: true,
      params: body,
      signal: options.signal,
    });
  },

  postShiftLocation(body, options = {}) {
    return apiCall.post({
      url: URL_ROSTERING_SHIFT_LOCATION,
      isAuthToken: token,
      skipQueryParams: true,
      params: body,
      signal: options.signal,
    });
  },
};

export default api;
